import { useEffect, useState } from 'react';
import { checkWindow, errorManager, ErrorService } from '@vfit/shared/data-access';
import { retrieveAppSession } from '@vfit/consumer/data-access';
import { getPostData } from './useEnergyFlow.utils';

export function useEnergyFlow(isEnergyPage: boolean) {
  const [isLoading, setIsLoading] = useState(isEnergyPage);
  const [isEligible, setIsEligible] = useState(false);

  const manageErrorEnergyOffer = () => {
    errorManager.handleError(ErrorService.getSeverityErrorHigh(), {
      title: 'Ops',
      message: 'Si è verificato un problema. Riprovare in seguito',
      actionText: 'Chiudi',
      fullscreen: true,
      disableCloseModalOnClickAction: true,
    });
  };

  const checkIsEnergyPage = () => {
    if (!checkWindow()) {
      return;
    }
    const { msisdn, account } = getPostData();
    if (!msisdn || !account) {
      manageErrorEnergyOffer();
      setIsEligible(false);
      setIsLoading(false);
    } else {
      setIsEligible(true);
      setIsLoading(false);
    }
  };

  useEffect(() => {
    if (isEnergyPage && !isLoading && !isEligible) {
      manageErrorEnergyOffer();
    }
  }, [isLoading, isEligible]);

  useEffect(() => {
    if (isEnergyPage) {
      retrieveAppSession();
      setTimeout(() => {
        checkIsEnergyPage();
      }, 1000);
    }
  }, []);

  return {
    isLoading,
    isEligible,
  };
}
